import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface IEditProfileCameraIconProps extends IConDefaultType {}

function EditProfileCameraIcon({ color, className, size = 24, rotate, flip }: IEditProfileCameraIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="16" fill={color || theme.color.icon.icon_2} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.5207 16.4206C27.5207 16.0144 27.1885 15.6852 26.7787 15.6852C26.3689 15.6852 26.0367 16.0144 26.0367 16.4206C26.0367 16.8268 26.3689 17.1561 26.7787 17.1561C27.1885 17.1561 27.5207 16.8268 27.5207 16.4206ZM24.6154 20.3672C24.6154 19.75 24.4933 19.1509 24.2524 18.5865C24.02 18.0418 23.6873 17.5526 23.2637 17.1327C22.8401 16.7129 22.3467 16.3831 21.797 16.1527C21.2277 15.914 20.6233 15.793 20.0005 15.793C19.3778 15.793 18.7734 15.914 18.2041 16.1527C17.6545 16.3831 17.161 16.7129 16.7374 17.1327C16.3138 17.5526 15.9811 18.0418 15.7487 18.5865C15.5078 19.1509 15.3857 19.75 15.3857 20.3672C15.3857 20.9845 15.5078 21.5836 15.7487 22.148C15.9811 22.6928 16.3138 23.1819 16.7374 23.6018C17.161 24.0216 17.6545 24.3514 18.2041 24.5818C18.7734 24.8205 19.3778 24.9415 20.0005 24.9415C20.6233 24.9415 21.2277 24.8205 21.797 24.5818C22.3467 24.3514 22.8401 24.0216 23.2637 23.6018C23.6873 23.1819 24.02 22.6928 24.2524 22.148C24.4933 21.5836 24.6154 20.9845 24.6154 20.3672ZM29.3346 25.99C29.3346 26.5819 28.8461 27.0661 28.249 27.0661H11.7536C11.1565 27.0661 10.668 26.5819 10.668 25.99V15.3655C10.668 14.7737 11.1565 14.2894 11.7536 14.2894H11.9668C12.0461 13.9361 12.3642 13.672 12.7444 13.672H13.7874C14.1677 13.672 14.4857 13.9361 14.565 14.2894H15.5758L16.415 12.8381C16.6672 12.4019 17.1357 12.1328 17.643 12.1328H22.3655C22.8727 12.1328 23.3412 12.4019 23.5935 12.8381L24.4327 14.2894H28.249C28.8461 14.2894 29.3346 14.7737 29.3346 15.3655V25.99ZM23.3177 20.3656C23.3177 22.1783 21.8299 23.653 20.0011 23.653C18.1724 23.653 16.6846 22.1783 16.6846 20.3656C16.6846 18.5529 18.1724 17.0781 20.0011 17.0781C21.8299 17.0781 23.3177 18.5529 23.3177 20.3656Z"
          fill={'white'}
        />
      </svg>
    </i>
  );
}

export default EditProfileCameraIcon;
